module.exports = __webpack_public_path__ + "static/media/heart-attack-symptoms-news.fea91037.jpg";